<template>
  <div>
    <label>低：{{ shockValue[0] ? numberFormat(shockValue[0]) : "-" }}%</label
    ><br />
    <label>高：{{ shockValue[1] ? numberFormat(shockValue[1]) : "-" }}%</label
    ><br />
    <label>均：{{ shockValue[2] ? numberFormat(shockValue[2]) : "-" }}%</label>
  </div>
</template>
<script>
import { BaseProgress } from "@/components/index";
import swal from "sweetalert2";

export default {
  name: "shock-label",
  components: {},

  created() {},
  props: {
    shockValue: Array,
  },
  methods: {
    numberFormat(num) {
      return parseFloat(num).toFixed(3);
    },
  },
};
</script>

<style>
</style>